'use strict';

export default function() {
  return {
    controller: function VideoController($scope, $uibModal) {
      'ngInject';

      var scope = $scope;

      $scope.showPopup = function showPopup() {
        $uibModal.open({
          //templateUrl: 'htmlPopup' + $scope.element.element_id,
          template: `
<div class="modal-content">
        <div class="modal-header">
            <h4 style="margin: 0; float: left;">${$scope.element.data.popupTitle}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="$close()"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
            <sgcontenteditor-editor-elements-display editor="$parent.editor" educator="$parent.educator" elements="$parent.element.children" tabdepth="$parent.tabdepth"></sgcontenteditor-editor-elements-display>
        </div>
    </div>
`,
          size: 'xlg',
          scope: $scope,
          //windowClass: 'htmlPopup',
          controller: function($scope, $uibModalInstance) {
            $scope.element = scope.element;
          }
        });
      };
    },
    template: require('./popuphtml.html'),
    link: function(scope, element, attr, ngModel) {
      if(scope.element.data.cssTrigger) {
        $(`.${scope.element.data.cssTrigger}`).click(function() {
          scope.showPopup();
        });
      }
    }
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/popuphtml.js